export default __webpack_public_path__ + "static/media/BottomLeftEllipse.c991bfde.svg";